module.exports = __webpack_public_path__ + "img/operador.7f1a7dd1.jpg";